<template>
  <div id="app">
    <router-view  />
    <!-- <keep-alive >
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive> -->
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue